import { defineMessages } from 'react-intl';

export default defineMessages({
  searchPlaceholder: {
    id: 'components.ProductSearch.placeholder',
    defaultMessage: 'Search for products...',
  },
});
